<template>
  <article class="feature">
    <div class="image" v-bind:backgroundColor="feature.backgroundColor">
      <img v-bind:src="getIcon()" alt="Svojstvo">
    </div>
    <div class="content">
      <span>{{feature.subtitle}}</span>
      <h2>{{feature.title}}</h2>
      <p>{{feature.description}}</p>
    </div>
  </article>
</template>

<style scoped>
.feature {
  font-family: "Fuse V.2 Display";
  color: #2c373f;
  max-width: 265px;
  width: 100%;
}
span {
  margin-top: 10px;
  min-height: 15px;
  text-transform: uppercase;
  color: #30cec1;
  font-family: "Fuse V.2 Display";
  font-size: 14px;
  font-weight: 800;
  line-height: 20px;
  display: table;
  margin-bottom: 5px;
}

article {
  margin-bottom: 80px;
}
p {
  opacity: 0.8;
  font-size: 14px;
  line-height: 22px;
}

h2 {
  font-size: 22px;
  line-height: 22px;
  margin-bottom: 15px;
}
.image {
  width: 52px;
  height: 52px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.image img {
  max-width: 100%;
  width: 100%;
  object-fit: contain;
}

[backgroundColor="#30CEC1"] {
  background-color: #30cec1;
}

[backgroundColor="#2C373F"] {
  background-color: #2c373f;
}

@media screen and (min-width: 768px) {
  .feature {
    display: flex;
    max-width: 100%;
  }

  .image {
    min-width: 52px;
    min-width: 76px;
    height: 76px;
    padding: 15px;
  }

  span {
    margin-top: 0;
  }

  .content {
    margin-left: 20px;
    flex: auto;
  }

  span {
    font-size: 20px;
    line-height: 24px;
  }

  h2 {
    font-size: 30px;
    line-height: 36px;
  }

  p {
    font-size: 18px;
    line-height: 32px;
  }
}

@media screen and (min-width: 1024px) {
  .feature {
    max-width: 425px;
  }
}
</style>

<script>
export default {
  name: "Feature",
  props: {
    feature: {}
  },
  methods: {
    getIcon: function() {
      return require(`../../assets/icons/${this.feature.icon}.svg`);
    }
  }
};
</script>
